import { Images } from "@spoferan/spoferan-ts-core";
import { mdiEarth, mdiFacebook, mdiInstagram, mdiTwitter, mdiYoutube } from "@mdi/js";
export function useSocialMedia() {
  const socialMediaConfig = {
    spoferan: {
      name: "SPOFERAN",
      image: Images.spoferan.icon,
      color: "#008200"
    },
    facebook: {
      name: "Facebook",
      icon: mdiFacebook,
      color: "#3b5998"
    },
    instagram: {
      name: "Instagram",
      icon: mdiInstagram,
      color: "#e4405f"
    },
    youtube: {
      name: "YouTube",
      icon: mdiYoutube,
      color: "#ff0000"
    },
    website: {
      name: "Website",
      icon: mdiEarth,
      color: "#465050"
    },
    twitter: {
      name: "Twitter",
      icon: mdiTwitter,
      color: "#1da1f2"
    },
    strava: {
      name: "Strava",
      image: Images.strava.app,
      color: "#fc4c02"
    }
  };
  return {
    config: socialMediaConfig
  };
}
